import * as angular from 'angular';
import { ViewportController } from '../../../../../app.common/modules/common/controllers/viewport-typed.controller';

class WarningsController extends ViewportController {
    static $inject = ['$scope', '$translate'];
    constructor(
        private $scope: ng.IScope,
        private $translate: angular.translate.ITranslateService
    ) {
        super($scope);
    }
}

angular
    .module('naut')
    .component('warnings', {
        template: require('./warnings.component.html'),
        controller: WarningsController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/warnings/components/warnings/warnings.component.ts